import clsx from "clsx";
import type { ButtonHTMLAttributes } from "react";

interface HamburgerButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isOpen?: boolean;
}

export function HamburgerButton({
  isOpen = false,
  className,
  "aria-label": ariaLabel,
  ...props
}: HamburgerButtonProps) {
  const label = ariaLabel ?? (isOpen ? "Close menu" : "Open menu");

  const lineBase = "h-0.5 w-full rounded bg-current transition-transform duration-200 ease-in-out";

  return (
    <button
      type="button"
      aria-label={label}
      aria-expanded={isOpen}
      className={clsx(
        "inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-300/60 bg-white/80 text-slate-700 shadow-sm backdrop-blur transition hover:bg-white",
        className
      )}
      {...props}
    >
      <span className="sr-only">{label}</span>
      <span className="flex h-5 w-6 flex-col justify-between py-0.5">
        {[0, 1, 2, 3].map((index) => (
          <span
            key={index}
            className={clsx(
              lineBase,
              "origin-center",
              index === 0 && isOpen && "translate-y-1.5 rotate-45",
              index === 1 && isOpen && "opacity-0",
              index === 2 && isOpen && "opacity-0",
              index === 3 && isOpen && "-translate-y-1.5 -rotate-45"
            )}
          />
        ))}
      </span>
    </button>
  );
}
